import { useEffect } from "react";

const SITE = "https://mytheatre.uk";
const SITE_NAME = "My Theatre";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function tidy(text, max = 158) {
  if (!text || text.length <= max) return text || "";
  return text.slice(0, max - 3).replace(/\s+\S*$/, "") + "...";
}

export function lowestFrom(links) {
  let lowest = null;
  for (const t of links || []) {
    const m = (t.starting_from || "").match(/[\d,]+\.?\d*/);
    if (!m) continue;
    const v = parseFloat(m[0].replace(/,/g, ""));
    if (!isNaN(v) && (lowest === null || v < lowest)) lowest = v;
  }
  return lowest;
}

export function showDescription(show) {
  const price = lowestFrom(show.ticket_links);
  const where = show.venue ? ` at ${show.venue}` : "";
  const from = price !== null ? ` from £${price.toFixed(2)}` : "";
  return `${show.name}${where}: compare ticket prices${from}, see the current cast and get alerts for cast changes.`;
}

export function Seo({ title, description, path, image, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const desc = tidy(description);
    const cleanPath = (path ?? window.location.pathname).replace(/\/+$/, "") || "/";
    const url = SITE + cleanPath;

    document.title = fullTitle;
    if (desc) {
      setMeta("name", "description", desc);
      setMeta("property", "og:description", desc);
      setMeta("name", "twitter:description", desc);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    } else {
      document.head
        .querySelectorAll('meta[property="og:image"], meta[name="twitter:image"]')
        .forEach((el) => el.remove());
    }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(url);
  }, [title, description, path, image, noindex]);

  return null;
}